import type { MRT_ColumnDef } from '@brightdrop/table-ui';
import type { EligibleVehicleResponseDto } from '~/api/generated-api';
import { TABLE_COLUMN_MIN_WIDTH } from '~/common/components/bps/table/table.constants';
import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import VehicleIdentityCellRenderer from '~/features/assets/components/VehicleIdentityCellRenderer/VehicleIdentityCellRenderer';
import { LicensePlateCell } from '~/features/assets/report/MRT/configs/cells/LicensePlateCell';

const LICENSE_PLATE_COLUMN_DEF = (): MRT_ColumnDef<
  EligibleVehicleResponseDto,
  string
> => ({
  accessorKey: 'licensePlate',
  header: translateText('asset:licensePlate'),
  minSize: TABLE_COLUMN_MIN_WIDTH,
  Cell: (props) => <LicensePlateCell<EligibleVehicleResponseDto> {...props} />,
});

const VEHICLE_NAME_COLUMN_DEF =
  (): MRT_ColumnDef<EligibleVehicleResponseDto> => ({
    id: 'coast-vehicle-name',
    accessorKey: 'name',
    header: translateText('common:vehicle'),
    minSize: TABLE_COLUMN_MIN_WIDTH,
    Cell: ({ row }) => {
      const vehicle = row.original;
      return (
        <VehicleIdentityCellRenderer
          vin={vehicle.vin ?? ''}
          name={vehicle.name ?? vehicle.vin ?? vehicle.id}
          imageUrl=""
          vehicleTypeDetail={[
            vehicle.vehicleYear,
            vehicle.vehicleMake,
            vehicle.vehicleModel,
          ]
            .filter(Boolean)
            .join(' ')}
        />
      );
    },
  });

export const getCoastEligibleVehiclesColumns = () => [
  VEHICLE_NAME_COLUMN_DEF(),
  {
    accessorKey: 'fleetName',
    header: translateText('common:fleet'),
    minSize: TABLE_COLUMN_MIN_WIDTH,
  },
  LICENSE_PLATE_COLUMN_DEF(),
];
